import React, { useMemo } from 'react';
import { DisciplineLiveStatus, DisciplineVirtualStatus, SportCounterType } from '@om-fe/models';
import { SportsNavType, SportsNavCounterType } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.constants';
import { getCounterType, getSportsNavTopic } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.utils.ts';
import { UseSportsNavStore, NavTopicStoreCreatorProps, useNavTopicStoreCreator, SportsNavOptions } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.hooks.ts';
export function useNavLiveSportsTopicStoreCreator(hasAllSports: boolean, favorites: number): UseSportsNavStore {
    const topic: string = getSportsNavTopic(SportsNavType.Live);

    const liveCounterType: SportCounterType | undefined = getCounterType(
        SportsNavType.Live,
        true,
        SportsNavCounterType.NumberOfEvents,
    );
    const upcomingCounterType: SportCounterType | undefined = getCounterType(
        SportsNavType.Live,
        false,
        SportsNavCounterType.NumberOfEvents,
    );

    const topicDetails: NavTopicStoreCreatorProps = React.useMemo(() => {
        return {
            liveStatus: DisciplineLiveStatus.LIVE,
            virtualStatus: DisciplineVirtualStatus.NOT_VIRTUAL,
            liveCounterType,
            upcomingCounterType,
        };
    }, [liveCounterType, upcomingCounterType]);

    const topicOptions: SportsNavOptions = useMemo(() => {
        return {
            favorites,
            hasAllSports,
            sportsNavType: SportsNavType.Live,
        };
    }, [hasAllSports, favorites]);

    return useNavTopicStoreCreator(
        topic,
        topicDetails,
        topicOptions,
    );
}
